// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Caixa_MovimentacaoInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /caixa/movimentacao
 */
import { registerContract } from './validate'

export interface Caixa_MovimentacaoInput {
caixa_abertura_id: number
tipo: string
valor: number
entrada_saida: string
forma_pagamento?: string
cofre_id?: number
origem?: string
origem_id?: number
observacao?: string
}

registerContract('Caixa_MovimentacaoInput', {
  caixa_abertura_id: { type: 'number',  required: true },
  tipo:              { type: 'string',  required: true },
  valor:             { type: 'number',  required: true },
  entrada_saida:     { type: 'string',  required: true },
  forma_pagamento:   { type: 'string',  required: false },
  cofre_id:          { type: 'number',  required: false },
  origem:            { type: 'string',  required: false },
  origem_id:         { type: 'number',  required: false },
  observacao:        { type: 'string',  required: false },
})
